import en from "../languages/en.json";
import ja from "../languages/ja.json";
import ko from "../languages/ko.json";
import cn from "../languages/zh.json";
import tc from "../languages/tc.json";
import vi from "../languages/vi.json";
import id from "../languages/ind.json";
import pt from "../languages/pt.json";
import es from "../languages/es.json";
import { FlagBrazil } from "../components/Icons/FlagBrazil";

export const languages = [
  {
    id: "ja",
    name: "日本語",
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <g clipPath="url(#clip0_19114_17025)">
          <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#F0F0F0"/>
          <path d="M12.8726 17.7173C15.7541 17.7173 18.09 15.3814 18.09 12.5C18.09 9.61849 15.7541 7.28259 12.8726 7.28259C9.99117 7.28259 7.65527 9.61849 7.65527 12.5C7.65527 15.3814 9.99117 17.7173 12.8726 17.7173Z" fill="#D80027"/>
        </g>
        <defs>
          <clipPath id="clip0_19114_17025">
            <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "en",
    name: "English",
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path d="M24.7715 10.9348H14.4383H14.4383V0.601578C13.9259 0.534875 13.4035 0.5 12.873 0.5C12.3425 0.5 11.8202 0.534875 11.3078 0.601578V10.9347V10.9347H0.974625C0.907922 11.4471 0.873047 11.9695 0.873047 12.5C0.873047 13.0306 0.907922 13.5529 0.974625 14.0652H11.3077H11.3078V24.3984C11.8202 24.4651 12.3425 24.5 12.873 24.5C13.4035 24.5 13.9259 24.4652 14.4382 24.3984V14.0653V14.0653H24.7715C24.8382 13.5529 24.873 13.0306 24.873 12.5C24.873 11.9695 24.8382 11.4471 24.7715 10.9348Z" fill="#D80027"/>
        <path d="M16.0039 15.6305L21.3587 20.9854C21.605 20.7392 21.8399 20.4818 22.0641 20.215L17.4796 15.6305H16.0039V15.6305Z" fill="#D80027"/>
        <path d="M9.74255 15.6305H9.74246L4.3877 20.9853C4.63388 21.2315 4.89127 21.4665 5.15809 21.6906L9.74255 17.1061V15.6305Z" fill="#D80027"/>
        <path d="M9.7428 9.3696V9.36951L4.38799 4.01465C4.14171 4.26084 3.90677 4.51823 3.68262 4.78504L8.26713 9.36955H9.7428V9.3696Z" fill="#D80027"/>
        <path d="M16.0039 9.36968L21.3588 4.01478C21.1126 3.7685 20.8552 3.53356 20.5884 3.30945L16.0039 7.89396V9.36968Z" fill="#D80027"/>
      </svg>
    ),
  },
  {
    id: "ko",
    name: "한국어",
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <g clipPath="url(#clip0_19114_17028)">
          <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#F0F0F0"/>
          <path d="M17.047 12.4999C17.047 13.5434 15.1783 16.1521 12.8731 16.1521C10.5679 16.1521 8.69922 13.5434 8.69922 12.4999C8.69922 10.1947 10.5679 8.32605 12.8731 8.32605C15.1783 8.32605 17.047 10.1947 17.047 12.4999Z" fill="#D80027"/>
          <path d="M17.047 12.5C17.047 14.8052 15.1783 16.6739 12.8731 16.6739C10.5679 16.6739 8.69922 14.8052 8.69922 12.5" fill="#0052B4"/>
          <path d="M17.2969 16.1895L18.4035 15.0829L19.1412 15.8206L18.0346 16.9272L17.2969 16.1895Z" fill="black"/>
          <path d="M15.4521 18.0338L16.5587 16.9272L17.2965 17.665L16.1899 18.7716L15.4521 18.0338Z" fill="black"/>
          <path d="M19.5098 18.4026L20.6164 17.296L21.3541 18.0337L20.2475 19.1403L19.5098 18.4026Z" fill="black"/>
          <path d="M17.665 20.2472L18.7716 19.1406L19.5094 19.8783L18.4028 20.9849L17.665 20.2472Z" fill="black"/>
          <path d="M18.4033 17.296L19.5099 16.1894L20.2477 16.9272L19.1411 18.0338L18.4033 17.296Z" fill="black"/>
          <path d="M16.5596 19.1405L17.6662 18.0339L18.4039 18.7716L17.2973 19.8782L16.5596 19.1405Z" fill="black"/>
          <path d="M19.5146 8.81262L16.5637 5.86168L17.3015 5.12394L20.2524 8.07488L19.5146 8.81262Z" fill="black"/>
          <path d="M16.5635 8.0752L15.4569 6.9686L16.1946 6.23089L17.3012 7.33748L16.5635 8.0752Z" fill="black"/>
          <path d="M18.4082 9.91992L17.3016 8.81332L18.0393 8.07561L19.1459 9.18221L18.4082 9.91992Z" fill="black"/>
          <path d="M18.7764 5.86157L17.6698 4.75497L18.4075 4.01723L19.5141 5.12383L18.7764 5.86157Z" fill="black"/>
          <path d="M20.6221 7.70654L19.5155 6.59994L20.2532 5.8622L21.3598 6.9688L20.6221 7.70654Z" fill="black"/>
          <path d="M5.12695 17.2939L8.07789 20.2449L7.34015 20.9826L4.38921 18.0317L5.12695 17.2939Z" fill="black"/>
          <path d="M8.07812 18.0311L9.18472 19.1377L8.44701 19.8754L7.34042 18.7688L8.07812 18.0311Z" fill="black"/>
          <path d="M6.2334 16.1871L7.34 17.2937L6.60225 18.0315L5.49566 16.9249L6.2334 16.1871Z" fill="black"/>
          <path d="M7.33984 15.0802L10.2908 18.0311L9.55304 18.7689L6.6021 15.8179L7.33984 15.0802Z" fill="black"/>
          <path d="M8.07812 4.75269L5.12718 7.70363L4.38944 6.96588L7.34038 4.01494L8.07812 4.75269Z" fill="black"/>
          <path d="M9.18457 5.85913L6.23363 8.81007L5.49589 8.07233L8.44683 5.12139L9.18457 5.85913Z" fill="black"/>
          <path d="M10.292 6.96643L7.34105 9.91737L6.60334 9.17966L9.55428 6.22872L10.292 6.96643Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_19114_17028">
            <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "cn",
    name: "简体中文",
    icon: () => (
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19114_17031)">
      <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#D80027"/>
      <path d="M7.44023 7.80322L8.47617 10.9907H11.8277L9.11836 12.9642L10.1543 16.1517L7.44023 14.1829L4.72617 16.1517L5.7668 12.9642L3.05273 10.9907H6.4043L7.44023 7.80322Z" fill="#FFDA44"/>
      <path d="M15.1 19.086L14.3078 18.111L13.1359 18.5657L13.8156 17.511L13.0234 16.5313L14.2375 16.8547L14.9219 15.8L14.9875 17.0563L16.2063 17.3797L15.0297 17.8297L15.1 19.086Z" fill="#FFDA44"/>
      <path d="M16.675 16.2266L17.05 15.0266L16.0234 14.3L17.2797 14.2813L17.65 13.0813L18.0578 14.2719L19.3141 14.2579L18.3062 15.0079L18.7094 16.1985L17.6828 15.4719L16.675 16.2266Z" fill="#FFDA44"/>
      <path d="M18.7977 9.30784L18.2445 10.4375L19.1445 11.3141L17.9023 11.136L17.3492 12.261L17.1336 11.0235L15.8867 10.8453L17.0023 10.2594L16.7867 9.01721L17.6867 9.89377L18.7977 9.30784Z" fill="#FFDA44"/>
      <path d="M15.1322 5.88599L15.0385 7.13755L16.2057 7.61099L14.9822 7.91099L14.8932 9.16724L14.2322 8.09849L13.0088 8.39849L13.8197 7.43755L13.1541 6.37349L14.3213 6.84692L15.1322 5.88599Z" fill="#FFDA44"/>
      </g>
      <defs>
      <clipPath id="clip0_19114_17031">
      <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
      </clipPath>
      </defs>
      </svg>

    ),
  },
  {
    id: "tc",
    name: "繁體中文",
    icon: () => (
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_19114_17031)">
        <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#D80027"/>
        <path d="M7.44023 7.80322L8.47617 10.9907H11.8277L9.11836 12.9642L10.1543 16.1517L7.44023 14.1829L4.72617 16.1517L5.7668 12.9642L3.05273 10.9907H6.4043L7.44023 7.80322Z" fill="#FFDA44"/>
        <path d="M15.1 19.086L14.3078 18.111L13.1359 18.5657L13.8156 17.511L13.0234 16.5313L14.2375 16.8547L14.9219 15.8L14.9875 17.0563L16.2063 17.3797L15.0297 17.8297L15.1 19.086Z" fill="#FFDA44"/>
        <path d="M16.675 16.2266L17.05 15.0266L16.0234 14.3L17.2797 14.2813L17.65 13.0813L18.0578 14.2719L19.3141 14.2579L18.3062 15.0079L18.7094 16.1985L17.6828 15.4719L16.675 16.2266Z" fill="#FFDA44"/>
        <path d="M18.7977 9.30784L18.2445 10.4375L19.1445 11.3141L17.9023 11.136L17.3492 12.261L17.1336 11.0235L15.8867 10.8453L17.0023 10.2594L16.7867 9.01721L17.6867 9.89377L18.7977 9.30784Z" fill="#FFDA44"/>
        <path d="M15.1322 5.88599L15.0385 7.13755L16.2057 7.61099L14.9822 7.91099L14.8932 9.16724L14.2322 8.09849L13.0088 8.39849L13.8197 7.43755L13.1541 6.37349L14.3213 6.84692L15.1322 5.88599Z" fill="#FFDA44"/>
        </g>
        <defs>
        <clipPath id="clip0_19114_17031">
        <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
        </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "vi",
    name: "Tiếng Việt",
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <g clipPath="url(#clip0_19114_17037)">
          <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#D80027"/>
          <path d="M12.8726 6.76086L14.1677 10.7466H18.3585L14.968 13.2099L16.2631 17.1957L12.8726 14.7323L9.48212 17.1957L10.7772 13.2099L7.38672 10.7466H11.5775L12.8726 6.76086Z" fill="#FFDA44"/>
        </g>
        <defs>
          <clipPath id="clip0_19114_17037">
            <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "id",
    name: "Indonesia",
    icon: () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <g clipPath="url(#clip0_19114_17040)">
          <path d="M12.873 24.5C19.5005 24.5 24.873 19.1274 24.873 12.5C24.873 5.87258 19.5005 0.5 12.873 0.5C6.24563 0.5 0.873047 5.87258 0.873047 12.5C0.873047 19.1274 6.24563 24.5 12.873 24.5Z" fill="#F0F0F0"/>
          <path d="M0.873047 12.5C0.873047 5.87262 6.24567 0.5 12.873 0.5C19.5004 0.5 24.873 5.87262 24.873 12.5" fill="#A2001D"/>
        </g>
        <defs>
          <clipPath id="clip0_19114_17040">
            <rect width="24" height="24" fill="white" transform="translate(0.873047 0.5)"/>
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "pt",
    name: "Português",
    icon:() => (
      <img src="/assets/images/pt.svg" alt="pt" />
    ),
  },
  {
    id: "es",
    name: "Español",
    icon:()=> (
      <img src="/assets/images/es.svg" alt="es" />
    ),
  },
];
export const languageCodes = languages.map((item) => item.id);
export const translations = { en: en, ja: ja, ko: ko, cn: cn, tc, vi, id, pt, es };
export const defaultLanguage = "en";
